import { render, staticRenderFns } from "./gameSingle.vue?vue&type=template&id=6822b1d3&scoped=true"
import script from "./gameSingle.vue?vue&type=script&lang=js"
export * from "./gameSingle.vue?vue&type=script&lang=js"
import style0 from "./gameSingle.vue?vue&type=style&index=0&id=6822b1d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822b1d3",
  null
  
)

export default component.exports